import styled from 'styled-components';

import { Color } from '../../../../constants/Colors';
import { MediaQuery, Shadow } from '../../../../constants/Styles';
import { Typography } from '../../../../constants/Typographies';

export const Section = styled.div`
  margin: ${({ hasAdditionalPadding }) =>
    hasAdditionalPadding ? '0 15px 30px 15px' : '0 15px 0 15px'};

  ${MediaQuery.XL_AND_DOWN} {
    margin: 0 0 15px 0;
  }
`;

export const SectionLabel = styled.p`
  ${Typography.XL_BOLDER};
  color: ${Color.CLOUD_BURST};
  padding: 30px 15px 10px 15px;

  ${MediaQuery.XL_AND_DOWN} {
    padding: 10px;
  }
`;

export const HeaderLink = styled.a`
  cursor: pointer;
  border: none;
  width: 250px;
  background: transparent;
  display: flex;
  padding: 10px 15px;
  border-radius: 10px;
  transition: transform 0.3s ease;

  & > :first-child {
    flex: none;
    margin-right: 10px;
  }

  ${MediaQuery.XL_AND_UP} {
    &:hover {
      transform: translateY(-2px) scale(1.005) translateZ(0);
      box-shadow: ${Shadow.BLUE_ACTIVE};
    }
  }

  &:focus {
    outline: 2px solid ${Color.CLOUD_BURST};
    background: ${Color.WHISPER};
    border-radius: 10px;
  }

  ${MediaQuery.XL_AND_DOWN} {
    width: auto;
    padding: 10px;
  }
`;

export const LinkWrapper = styled.div`
  padding-top: 5px;
`;

export const LinkLabel = styled.p`
  ${Typography.S_BOLDER};
  color: ${Color.CLOUD_BURST};
`;

export const LinkDescription = styled.p`
  ${Typography.XS};
  color: ${Color.DOLPHIN};
  padding-top: 5px;
`;
